module.exports = __webpack_public_path__ + "static/media/pdf.dc63a55d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/files/pdf.png
// module id = 801
// module chunks = 2